module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('span', {
    staticStyle: {
      "width": "50px",
      "vertical-align": "middle"
    }
  }, [_c('router-link', {
    staticClass: "fa fa-edit",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "to": {
        path: '/FieldworkRequest/' + _vm.fieldworkRequest.fieldworkRequestId
      },
      "tag": "a"
    }
  })], 1), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "label"
  }, [_vm._v("Request DBA No.")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.fieldworkRequest.dbNumber))])]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "label"
  }, [_vm._v("Field Org. Project No.")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.fieldworkRequest.fieldOrganizationProjectNumber))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-013674d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FieldworkRequestHeader.vue
// module id = 882
// module chunks = 1